import BeltMapAndTrend from './BeltMapAndTrend/BeltMapAndTrend';
import { BeltVisualEvidence } from './BeltVisualEvidence/BeltVisualEvidence';
import { BaseCard } from '@/components/uiKit/Cards';
import { HealthStatusFilter } from '../HealthStatusFilter';

interface TopSectionProps {
  beltDefects: any[];
  selectedDefectId: string;
  onDefectClick: (id: string) => void;
  beltConfig: any;
  allDefects: any[];
  selectedItem: any;
  handlePreviousItem: () => void;
  handleNextItem: () => void;
  healthFilters: Set<string>;
  handleFilterChange: (filters: Set<string>) => void;
  lastInspectionDate: string;
  formatDateDisplay: (date: string) => string;
}

export function TopSection({
  beltDefects,
  selectedDefectId,
  onDefectClick,
  beltConfig,
  allDefects,
  selectedItem,
  handlePreviousItem,
  handleNextItem,
  healthFilters,
  handleFilterChange,
  lastInspectionDate,
  formatDateDisplay,
}: TopSectionProps) {
  return (
    <BaseCard
      title={
        <div className="flex w-full h-full justify-between items-center text-sm px-2">
          <span>Conveyor Map and Trends</span>
          <div className="flex items-center gap-4">
            <HealthStatusFilter healthFilters={healthFilters} onFilterChange={handleFilterChange} />
            {/* <span className="font-medium text-subtext">{`Last Verified: ${formatDateDisplay(lastInspectionDate)}`}</span> */}
          </div>
        </div>
      }
      variant="wrapper"
      classNames={{
        card: 'flex flex-col h-full',
        content: 'flex flex-col gap-2 max-h-[calc(100%-2.5rem)] bg-gray-200 p-0',
      }}
    >
      <div>
        <BeltMapAndTrend
          malfunctions={beltDefects}
          selectedMalfunctionId={selectedDefectId}
          onMalfunctionClick={onDefectClick}
          beltConfig={beltConfig}
        />
      </div>
      <div className="flex-1 min-h-[350px]">
        <BeltVisualEvidence
          selectedItem={
            selectedItem
              ? {
                  type: selectedItem.type,
                  name: selectedItem.name,
                  status: selectedItem.status || 'healthy',
                  nextSplice: selectedItem.nextSplice,
                  positionLabel: selectedItem.positionLabel,
                  detectionImage: selectedItem.detectionImage,
                  afterImage: selectedItem.afterImage,
                }
              : undefined
          }
          onPreviousItem={handlePreviousItem}
          onNextItem={handleNextItem}
          hasPrevious={allDefects.length > 0}
          hasNext={allDefects.length > 0}
        />
      </div>
    </BaseCard>
  );
}
